import { Config, httpPost } from "../../services/api";
import { formatPaymentMethods } from "./utils";

export const sdkGetMethods = async ({
  intentType: _intentType,
  lang,
  publicApiKey,
  flowId,
  ...payload
}: {
  lang: string;
  intentType: "payment" | "payout";
  publicApiKey: string;
  currency: string;
  amount?: string | number;
  customer?: string;
  flowId?: string;
}) => {
  const response = await httpPost<{
    data: {
      express_methods: PaymentMethod[];
      payment_methods: PaymentMethod[];
      saved_cards?: SavedCard[];
      saved_bankaccounts?: SavedBankAccount[];
      customer_balances?: [
        {
          id: "SELFSERVE_WALLET";
          balance: number;
          icon: string;
        }
      ];
    };
  }>(
    `${import.meta.env.VITE_API_BASE}/api/${
      Config.apiVersion
    }/accounts/payment_methods/?lang=${lang}`,
    { ...payload, flow_id: flowId },
    true,
    {
      "x-public-key": publicApiKey,
    }
  );

  const {
    payment_methods,
    express_methods,
    saved_cards,
    customer_balances,
    saved_bankaccounts,
  } = response.data;

  return formatPaymentMethods({
    paymentMethods: payment_methods,
    expressMethods: express_methods,
    savedCards: saved_cards,
    savedBankAccounts: saved_bankaccounts,
    wallet: customer_balances?.find((b) => b.id === "SELFSERVE_WALLET")
      ?.balance,
  });
};
